<template>
  <!-- 开票记录 -->
  <el-card class="m-b" v-if="invoiceInfo">
    <div slot="header" class="clearfix">
      <span class="saas-card-header-name">开票记录</span>
    </div>
    <div class="order-content-detail">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="common-item">
            <span>开票单：</span>
            <span><router-link :to="{
              name: `${$store.state.system === 'purchaser' ? 'PurchaserInvoiceManageDetail' : 'SupplierInvoiceManageDetail'}`, query: {
                id: invoiceInfo.id,
                type: 'check'
              }}">{{invoiceInfo.invoiceCode}}</router-link></span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="common-item">
            <span>状态：</span>
            <span style="color:#FFA426;">{{getValue('invoiceStatus', invoiceInfo.status)}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="common-item">
            <span>申请开票金额(元)：</span>
            <span>{{_util.formatMoney(invoiceInfo.invoiceMoney)}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>
<script>
import { getValue } from '@/lib/enum'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      getValue,
      invoiceInfo: ''
    }
  },
  created() {
    this.initData()
  },
  // activated() {
  //   if (this.$route.params.isReLoad) {
  //     this.invoiceInfo = ''
  //     this.initData()
  //   }
  // },
  methods: {
    ...mapActions([
      'listInvoiceMainOrderByOrderId',
      'listInvoiceMainOrderByOrderIdGys'
    ]),
    // 获取开票记录
    async initData() {
      await this[`${this.$store.state.system === 'purchaser' ? 'listInvoiceMainOrderByOrderId' : 'listInvoiceMainOrderByOrderIdGys'}`]({
        orderId: this.$route.query.id
      }).then(res => {
        if (res && res.length) {
          this.invoiceInfo = {
            id: res[0].id,
            invoiceCode: res[0].invoiceCode,
            status: res[0].status,
            invoiceMoney: res[0].invoiceMoney
          }
        }
      })
    }
  }
}
</script>
